// --- SaniQ ---
import * as BrowserConstants from '../constants/Browsers';

const initialState = {
  collection: [],
  isFetching: false
};

export function browsers(state = initialState, action) {
  switch (action.type) {
    case BrowserConstants.BROWSERS_FETCH_STARTED:
      return Object.assign({}, state, {isFetching: true});
    case BrowserConstants.BROWSERS_FETCH_COMPLETED:
      return Object.assign({}, state, {
        collection: action.browsers,
        isFetching: false
      });
    case BrowserConstants.BROWSERS_DELETE_STARTED:
      return Object.assign({}, state, {isFetching: true});
    case BrowserConstants.BROWSERS_DELETE_COMPLETED:
      return Object.assign({}, state, {isFetching: false});
    default:
      return state;
  }
}
